import PropTypes from 'prop-types';
import React, { Component } from 'react';
import _ from 'lodash';
import FormValidations from 'data/FormValidations';
import { converter } from 'helpers/converter';
import Button from '../Button';
import InputMonthYear from './InputMonthYear';
import InputOptionCard from './InputOptionCard';
import InputSelect from './InputSelect';
import InputText from './InputText';
import './CreditCardFormProfile.scss';
import * as constants from './constants';
import Logger from 'services/logger';

class CreditCardFormProfile extends Component {
  constructor(props) {
    super(props);
    const { formValues } = props;
    this.state = {
      form: {
        name: formValues.name,
        cardProvider: formValues.cardProvider,
        cardNumber: formValues.cardNumber,
        cardNip: formValues.cardNip,
        expirationMonth: formValues.expirationMonth,
        expirationYear: formValues.expirationYear,
        address: formValues.address,
        city: formValues.city,
        state: formValues.state,
        zipCode: formValues.zipCode,
        phone: formValues.phone,
      },
      errors: {},
    };

    this.toggleCondensed = this.toggleCondensed.bind(this);
    this.updateField = this.updateField.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  toggleCondensed() {
    this.setState(current => ({ showShort: !current.showShort }));
  }

  updateField(e) {
    const updatedValue = { [e.target.name]: e.target.value };
    this.setState(currentState => {
      const result = Object.assign(currentState.form, updatedValue);
      return Object.assign(currentState, result);
    });
  }

  validateState = data => {
    const {
      name,
      cardProvider,
      cardNumber,
      cardNip,
      expirationMonth,
      expirationYear,
      address,
      city,
      state,
      zipCode,
      phone,
    } = data;
    const errors = {};
    const { translations } = this.props;

    // Validaciones del campo nombre de tarjeta
    _.assign(
      errors,
      new FormValidations(name, constants.FIELDS.NAME)
        .validateMinLongitude(
          3,
          converter.convertApa(translations, constants.EMPTY_NAME),
        )
        .validateNameFormat(
          converter.convertApa(translations, constants.INVALID_CC_HOLDER),
        )
        .getErrors(),
    );

    // Validaciones para el campo empresa
    _.assign(
      errors,
      new FormValidations(cardProvider, constants.FIELDS.CARD_PROVIDER)
        .isEqualTo(
          0,
          converter.convertApa(translations, constants.INVALID_CC_TYPE),
        )
        .getErrors(),
    );

    // Validaciones del campo numero de tarjeta
    _.assign(
      errors,
      new FormValidations(cardNumber, constants.FIELDS.CARD_NUMBER)
        .validateMinLongitude(
          15,
          converter.convertApa(translations, constants.INVALID_CC_TYPE),
        )
        .validateMaxLongitude(
          16,
          converter.convertApa(translations, constants.INVALID_CC_NUMBER),
        )
        .getErrors(),
    );

    // Validaciones del campo numero de seguridad
    _.assign(
      errors,
      new FormValidations(cardNip, constants.FIELDS.CARD_NIP)
        .validateMinLongitude(3, constants.NIP_ERROR_MESSAGE)
        .validateMaxLongitude(4, constants.NIP_ERROR_MESSAGE)
        .validateNumberFormat(constants.NIP_ERROR_MESSAGE)
        .getErrors(),
    );

    // validaciones del campo fecha de expiración
    _.assign(
      errors,
      new FormValidations(expirationMonth, constants.FIELDS.EXPIRATION_MONTH)
        .isEqualTo(
          '',
          converter.convertApa(translations, constants.INVALID_CC_DATE),
        )
        .getErrors(),
    );

    _.assign(
      errors,
      new FormValidations(expirationYear, constants.FIELDS.EXPIRATION_YEAR)
        .isEqualTo(
          '',
          converter.convertApa(translations, constants.INVALID_CC_DATE),
        )
        .getErrors(),
    );

    // Validaciones del campo direccion
    _.assign(
      errors,
      new FormValidations(address, constants.FIELDS.ADDRESS)
        .validateMinLongitude(
          1,
          converter.convertApa(translations, constants.EMPTY_ADDRESS),
        )
        .getErrors(),
    );

    // Validaciones del campo ciudad
    _.assign(
      errors,
      new FormValidations(city, constants.FIELDS.CITY)
        .validateMinLongitude(
          1,
          converter.convertApa(translations, constants.EMPTY_CITY),
        )
        .validateNameFormat(constants.ONLY_LETTERS)
        .getErrors(),
    );

    // Validaciones del campo estado
    _.assign(
      errors,
      new FormValidations(state, constants.FIELDS.STATE)
        .isEqualTo(
          '',
          converter.convertApa(translations, constants.EMPTY_STATE),
        )
        .getErrors(),
    );

    // Validaciones del campo codigo postal
    _.assign(
      errors,
      new FormValidations(zipCode, constants.FIELDS.ZIP_CODE)
        .validateMinLongitude(
          1,
          converter.convertApa(translations, constants.EMPTY_ZIP_CODE),
        )
        .validateNumberFormat(constants.ONLY_NUMBERS)
        .getErrors(),
    );

    // Validaciones del campo telefono
    _.assign(
      errors,
      new FormValidations(phone, constants.FIELDS.PHONE)
        .validateMinLongitude(
          1,
          converter.convertApa(translations, constants.EMPTY_PHONE),
        )
        .validateNumberFormat(constants.PHONE_ERROR_MESSAGE)
        .getErrors(),
    );

    return { errors, isValid: _.isEmpty(errors) };
  };

  isValid = () => {
    const { form } = this.state;
    const { errors, isValid } = this.validateState(form);
    if (!isValid) this.setState({ errors });
    else this.setState({ errors: {} });

    return isValid;
  };

  submitForm(e) {
    e.preventDefault();
    if (!this.isValid()) return;
    _.invoke(this.props, 'onSubmitForm', e, this.state.form);
  }

  onCancel(e) {
    e.preventDefault();
    this.toggleCondensed();
    if (typeof this.props.onCancelForm !== 'function') {
      return;
    }
    this.props.onCancelForm();
  }

  render() {
    const settings = Object.assign({}, DEFAULTS, this.props);
    const {
      labels,
      cardsList,
      inputs,
      statesList,
      placeholders,
      isSubmitting,
    } = settings;
    const { errors } = this.state;
    return (
      <form
        className="ccfp__content__form"
        onSubmit={this.submitForm}
        ref={this.setFormRef}
      >
        <p>{labels.LEGEND}</p>
        <div className="ccfp__content__form__left">
          <InputText
            label={inputs.NAME}
            name={constants.FIELDS.NAME}
            value={this.state.form.name}
            onChange={this.updateField}
            error={errors.name}
            placeholder={placeholders.NAME}
            isDisabled={isSubmitting}
          />
          <InputOptionCard
            label={inputs.CARD_PROVIDER}
            onChange={this.updateField}
            name={constants.FIELDS.CARD_PROVIDER}
            value={this.state.form.cardProvider}
            options={cardsList}
            error={errors.cardProvider}
            isDisabled={isSubmitting}
          />
          <InputText
            label={inputs.CARD_NUMBER}
            name={constants.FIELDS.CARD_NUMBER}
            value={this.state.form.cardNumber}
            onChange={this.updateField}
            error={errors.cardNumber}
            placeholder={placeholders.CARD_NUMBER}
            isDisabled={isSubmitting}
          />
          <InputText
            label={inputs.CARD_NIP}
            name={constants.FIELDS.CARD_NIP}
            value={this.state.form.cardNip}
            onChange={this.updateField}
            error={errors.cardNip}
            placeholder={placeholders.CARD_NIP}
            isDisabled={isSubmitting}
            type="password"
          />
          <InputMonthYear
            label={inputs.CARD_EXPIRATION}
            month={{
              name: constants.FIELDS.EXPIRATION_MONTH,
              value: this.state.form.expirationMonth,
              onChange: this.updateField,
              label: 'MM',
            }}
            year={{
              name: constants.FIELDS.EXPIRATION_YEAR,
              value: this.state.form.expirationYear,
              onChange: this.updateField,
              label: 'AAAA',
            }}
            error={errors.expirationMonth || errors.expirationYear}
            isDisabled={isSubmitting}
          />
          <InputText
            label={inputs.ADDRESS}
            name={constants.FIELDS.ADDRESS}
            value={this.state.form.address}
            onChange={this.updateField}
            error={errors.address}
            placeholder={placeholders.ADDRESS}
            isDisabled={isSubmitting}
          />
        </div>
        <div className="ccfp__content__form__right">
          <InputText
            label={inputs.CITY}
            name={constants.FIELDS.CITY}
            value={this.state.form.city}
            onChange={this.updateField}
            error={errors.city}
            placeholder={placeholders.CITY}
            isDisabled={isSubmitting}
          />
          <InputSelect
            label={inputs.STATE}
            onChange={this.updateField}
            name={constants.FIELDS.STATE}
            value={this.state.form.state}
            options={statesList}
            error={errors.state}
            placeholder={placeholders.STATE}
            isDisabled={isSubmitting}
          />
          <InputText
            label={inputs.ZIPCODE}
            name={constants.FIELDS.ZIP_CODE}
            value={this.state.form.zipCode}
            onChange={this.updateField}
            error={errors.zipCode}
            placeholder={placeholders.ZIPCODE}
            isDisabled={isSubmitting}
          />
          <InputText
            label={inputs.PHONE}
            name={constants.FIELDS.PHONE}
            value={this.state.form.phone}
            onChange={this.updateField}
            error={errors.phone}
            placeholder={placeholders.PHONE}
            isDisabled={isSubmitting}
            legend={labels.PHONE_LEGEND}
          />
          <p>{labels.POST_LEGEND}</p>

          <div className="ccfp__content__form__action-buttons">
            <div className="ccfp__content__form__action-buttons__submit">
              <Button
                onClick={this.submitForm}
                children={labels.BTN_SUBMIT}
                loading={isSubmitting}
              />
            </div>
            <div className="ccfp__content__form__action-buttons__cancel">
              <button
                disabled={isSubmitting}
                type="button"
                onClick={this.onCancel}
              >
                {labels.BTN_CANCEL}
              </button>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

CreditCardFormProfile.propTypes = {
  formValues: PropTypes.object,
  onSubmitForm: PropTypes.func,
  onCancelForm: PropTypes.func,
  labels: PropTypes.shape(),
  placeholders: PropTypes.shape(),
  inputs: PropTypes.shape(),
  cardNumber: PropTypes.string,
  cardLegend: PropTypes.string,
  cardsList: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string,
      image: PropTypes.string,
    }),
  ),
  statesList: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      text: PropTypes.string,
    }),
  ),
  isSubmitting: PropTypes.bool,
  errors: PropTypes.shape(),
  translations: PropTypes.object,
};

export const ENUMS = Object.freeze({
  NAME: 'NAME',
  CARD_NUMBER: 'CARD_NUMBER',
  CARD_NIP: 'CARD_NIP',
  CARD_EXPIRATION_MONT: 'CARD_EXPIRATION_MONT',
  CARD_EXPIRATION_YEAR: 'CARD_EXPIRATION_YEAR',
  ADDRESS: 'ADDRESS',
  CITY: 'CITY',
  STATE: 'STATE',
  ZIPCODE: 'ZIPCODE',
  PHONE: 'PHONE',
});

const DEFAULTS = {
  onSubmitForm: data => Logger.warn(data),
  cardLegend: 'Número de tarjeta: ',
  cardNumber: 'XXXX XXXX XXXX XXXX',
  labels: {
    TITLE: 'Modificar medio de pago',
    BTN_MODIFY: 'Modificar',
    LEGEND: 'Edita los datos correspondientes a tu tarjeta de crédito.',
    POST_LEGEND: '* Estos campos son obligatorios',
    PHONE_LEGEND:
      'Este télefono es de contacto para la validación de tu tarjeta de crédito',
    BTN_SUBMIT: 'Siguiente',
    BTN_CANCEL: 'Cancelar',
  },
  inputs: {
    NAME: 'Nombre que figura en la tarjeta *',
    CARD_PROVIDER: 'Empresa *',
    CARD_NUMBER: 'Número de tarjeta *',
    CARD_NIP: 'Código de seguridad *',
    CARD_EXPIRATION: 'Fecha de expiración *',
    ADDRESS: 'Dirección *',
    CITY: 'Ciudad *',
    STATE: 'Estado *',
    ZIPCODE: 'Código Postal *',
    PHONE: 'Teléfono *',
  },
  placeholders: {
    NAME: 'Ingresa tu nombre',
    CARD_NUMBER: 'Ingresa el número de tarjeta',
    CARD_NIP: 'CVV',
    CARD_EXPIRATION_MONT: 'MM',
    CARD_EXPIRATION_YEAR: 'AAAA',
    ADDRESS: 'Ingresa tu dirección',
    CITY: 'Ingresa tu localidad',
    STATE: 'Estado',
    ZIPCODE: 'Ingresa tu código postal',
    PHONE: 'Ingresa tu teléfono',
  },
  cardsList: [
    { code: 'amex', image: 'https://via.placeholder.com/25x16?text=amex' },
    { code: 'visa', image: 'https://via.placeholder.com/25x16?text=visa' },
    { code: 'master', image: 'https://via.placeholder.com/25x16?text=master' },
  ],
  statesList: [
    { value: 1, text: 'Ciudad de México' },
    { value: 2, text: 'Estado de México' },
  ],
  errors: {
    NAME: '',
    CARD_PROVIDER: '',
    CARD_NUMBER: '',
    CARD_NIP: '',
    CARD_EXPIRATION: '',
    ADDRESS: '',
    CITY: '',
    STATE: '',
    ZIPCODE: '',
    PHONE: '',
  },
};

export default CreditCardFormProfile;
